<template>
  <std-form-page
      ref="page"
      :id="script_id"
      :item="item"
      identity="script_id"

      :url="'/myprojects/'+project_id+'/scripts'"
      resource="script"

      icon="bi-diagram-3-fill"
      title-new="Создать новый сценарий"
      :title="'Сценарий ' + script_id + ' проекта ' + project_id"
      :no-edit="item?.readonly"
      back-button="К проекту"
  >


    <template v-slot:default>
      <f-input v-model="item.name" label="Название сценария" w="12"/>
      <f-input v-model="item.comment" type="textarea" label="Комментарий" w="12"/>
    </template>


    <template v-slot:actions="form">
      <button v-if="script_id && !form.edit" @click="$router.push({name:'flow', params:{id:id}})" type="button" class="btn btn-outline-primary">Конструктор{{ item?.readonly ? ' (read only)' : '' }}</button>
      <button v-if="form.edit" @click="onLoad" type="button" class="btn btn-outline-primary">Загрузить json</button>
      <button v-if="script_id && form.edit" @click="onSave" type="button" class="btn btn-outline-primary">Сохранить json</button>

      <button v-if="!form.edit" type="button" @click="onProvision(true)" class="btn btn-outline-primary">Тестировать</button>
      <button v-if="!form.edit && !item?.readonly" type="button" @click="onProvision(false)" class="btn btn-outline-warning">Установить</button>
    </template>

  </std-form-page>

</template>

<script>
import StdFormPage from "@/components/StdFormPage";
import FInput from "@/components/FInput";
import {clickDownloadJson, readTextFile, selectFile} from "@/misc/util";
import {http} from "@/misc/http";

export default {
  components: {FInput, StdFormPage},
  props: ["project_id", "script_id"],
  data() {
    return {
      item: {
        name: "Новый",
        flow: {},
        comment: ""
      },
    }
  },
  methods: {
    onSave() {
      clickDownloadJson(this.item.flow, this.item.name.replace('.', '_'));
    },

    onLoad() {
      selectFile(file => {
        readTextFile(file, async content => {
          try {
            const flow = JSON.parse(content);
            if (!flow.meta || flow.meta.type != "scenario" || flow.meta.version != "1.0.0")
              throw Error("Неподдерживаемый формат файла.");
            this.item.flow = flow;
            this.item.name = flow.meta.name;
            alert("Восстановлено.");
          } catch (e) {
            alert("Ошибка: " + e.message);
          }
        })
      });
    },

    async onProvision(test_mode) {
      this.$refs.page.$refs.loader.clear();

      if (!test_mode && !confirm(
          "Вы собираетесь установить сценарий в продакшн. " +
          "Это повлияет на весь последующий трафик проекта " + this.project_id + ". " +
          "Вы уверены?")) return;

      if (await this.$refs.page.wrap(async () => {
        await http.post("/myprojects/" + this.project_id + "/provision", {
          test_mode: test_mode,
          meta: {
            script_id: this.script_id,
          },
        });
        return "Проект успешно установлен" + (test_mode ? " в тестовом режиме." : ".");
      })) {
        if (test_mode) {
          const pid = this.project_id + "-test";
          window.open('/u/' + pid + '/' + pid + '?reset=1', "_blank");
        }
      }
    },

  },
}
</script>
